import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TaskService } from 'src/app/_services/task/task.service';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ProjectTaskService } from 'src/app/_services/project_task/project-task.service'
import { ProjectService } from 'src/app/_services/project/project.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {
  projectTaskGridForm
  // row data and column definitions  
  rowData: any;
  public columnDefs: ColDef[];
  modeAction: number = 1 //1 - create // 2 - update
  // gridApi and columnApi 
  private api: GridApi;
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any
  tenantId: string;
  gridApi: any;
  gridColumnApi: any;
  form: FormGroup;
  projectsData: any;
  userDetails: any;
  users: any;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  deleteConfirmationMsg = 'Are you sure you want to delete';
  currentProjectId: any;
  parentProjectId: any;
  ProjecttaskId: any;
  userDropdownList = [];
  projectDropdownList = [];
  taskDropdownList = [];
  // taskOwnerDropdown = [];
  taskOwnerDropdown: Array<any> = [];
  systemInformation: any; //Response of API call getSystemInformation()
  systemArray: any = []; //Array of all system
  subSystemArray: any = []; //Array of all sub-system Name
  selectedSystem: any; //Selected System in HTML
  selectedSubSystem: any; //Selected System in HTML
  subSubSystemArray: any = []; //Array of all Sub sub-system Name
  selectedFile: File;
  orphanFiles: File[];
  projectTaskAttachments: any;
  attachmentId: any;
  attachemntName: any;
  ignoreSnackbar: boolean;
  projectTaskId: any;
  isPMOLeadORManager: boolean = false;
  isAdministrator: boolean = false;
  projectName: any;

  constructor(
    private taskService: TaskService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private router: Router,
    private storageService: LocalStorageService,
    private route: ActivatedRoute,
    private projecttaskService: ProjectTaskService,
    private projectService: ProjectService,
    private allocationService: AllocationService,
    private projectResourcesService: ProjectResourcesService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.projectTaskGridForm = new FormGroup({
      id: new FormControl(''),
      name: new FormControl(''),
      projectId: new FormControl(''),
      projectName: new FormControl(''),
      system: new FormControl(''),
      subSystem: new FormControl(''),
      subSubSystem: new FormControl(''),
      description: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      taskOwnerId: new FormControl(''),
      taskOwnerName: new FormControl(''),
      estimatedTimeInHours: new FormControl(''),
      parentId: new FormControl(''),
      parentName: new FormControl(''),
      status: new FormControl(''),
      plannedStartDate: new FormControl(''),
      plannedEndDate: new FormControl(''),
      predecessorProjectTaskId: new FormControl(''),
      predecessorProjectTaskName: new FormControl(''),
      successorProjectTaskId: new FormControl(''),
      successorProjectTaskName: new FormControl(''),
      percentWorkCompleted: new FormControl(''),
      plannedStatus: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');

    this.getProjectResource();
    this.getSystemInformation();
    this.getUserList();
    this.getAllTasksById();
    this.getprojectsList();
    this.getProjectById(this.currentProjectId);

    this.getTaskForCurrentProject();
  }

  getTaskForCurrentProject() {
    this.projecttaskService.getAllProjectTaskByProjectId(this.currentProjectId).subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

  openProjectTab(param) {
    if (this.parentProjectId) {
      this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId } }); // pass current project id as parameter
    }
    else {
      this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
    }
  }

  backToMyProject() {
    if (this.parentProjectId) {
      this.router.navigate([this.tenantId + '/dashboard/project/project-list/sub-project-list'], { queryParams: { projectID: this.parentProjectId } });
    } else {
      this.router.navigate([this.tenantId + '/dashboard/project/project-list/myproject']);
    }
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: 'Name',
        field: 'name',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Task Owner Name',
        field: 'taskOwnerName',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Business Group',
        field: 'system',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Commodity',
        field: 'subSystem',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Part List',
        field: 'subSubSystem',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'EndDate',
        field: 'endDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Estimated Time(Hrs)',
        field: 'estimatedTimeInHours',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Completed Time(Hrs)',
        field: 'totalTimesheetApprovedHours',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: "% for Completion",
        valueGetter: function (params) {
          return params.data.percentWorkCompleted + '%';
        },
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      {
        headerName: 'Status',
        field: 'status',
        cellStyle: (params) => {
          if (params.value === 'Open' || params.value === 'open') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Close' || params.value === 'close') {
            return { color: 'blue', 'font-weight': 'bold' };
          }
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
        hide: false,
      },
      {
        headerName: 'Task OwnerName',
        field: 'taskOwnerName',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Parent Name',
        field: 'parentName',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      }
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createOpenModal() {
    this.modeAction = 1;
    this.projectTaskGridForm.reset();
    this.projectTaskAttachments = [];
    this.orphanFiles = [];
    this.projectTaskGridForm.patchValue({
      id: '',
      name: '',
      projectName: this.projectName,
      system: '',
      subSystem: '',
      subSubSystem: '',
      description: '',
      startDate: '',
      endDate: '',
      taskOwnerId: '',
      taskOwnerName: '',
      estimatedTime: '',
      parentId: '',
      parentName: '',
      status: '',
      predecessorProjectTaskId: '',
      successorProjectTaskId: '',
      plannedStartDate: '',
      plannedEndDate: '',
      percentWorkCompleted: '',
      plannedStatus: ''
    });
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.projectTaskId = this.selectedCheckboxData[0].id;
    this.getProjectTaskAttachments(this.projectTaskId);
    this.projectTaskGridForm.patchValue(this.selectedCheckboxData[0]);
    this.getSystemInformation();
    this.getSubSystemInformation(this.selectedCheckboxData[0].system);
    this.getSubSubSystemInformation(this.selectedCheckboxData[0].subSystem);
    this.projectTaskGridForm.value.projectName = this.selectedCheckboxData[0].projectId + " . " + this.selectedCheckboxData[0].projectName;
    this.projectTaskGridForm.value.taskOwnerName = this.projectTaskGridForm.value.taskOwnerId + " . " + this.projectTaskGridForm.value.taskOwnerName;
    this.projectTaskGridForm.value.parentName = this.projectTaskGridForm.value.parentId + " . " + this.projectTaskGridForm.value.parentName;
    this.projectTaskGridForm.value.estimatedTime = this.projectTaskGridForm.value.estimatedTime;
    this.projectTaskGridForm.value.subSystem = this.selectedCheckboxData[0].subSystem;
    this.projectTaskGridForm.value.subSubSystem = this.selectedCheckboxData[0].subSubSystem;
    this.projectTaskGridForm.value.predecessorProjectTaskId = this.projectTaskGridForm.value.predecessorProjectTaskId + " . " + this.projectTaskGridForm.value.predecessorProjectTaskName;
    this.projectTaskGridForm.value.successorProjectTaskId = this.projectTaskGridForm.value.successorProjectTaskId + " . " + this.projectTaskGridForm.value.successorProjectTaskName;
    this.projectTaskGridForm.patchValue(this.projectTaskGridForm.value);
  }

  getUserList() {
    this.userDropdownList = []
    this.allocationService.getUserDetails().subscribe(response => {
      for (let item of response) {
        this.userDropdownList.push(`${item.id} . ${item.firstName} ${item.lastName}`)
      }
    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }
  }

  private deleteGridRow(params: any) {
    this.taskService.deleteProjectTasks(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].taskOwnerName} ${this.selectedCheckboxData[i].name}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].taskOwnerName} ${this.selectedCheckboxData[i].name}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].taskOwnerName} ${this.selectedCheckboxData[i].name}`;
    }
  }

  deleteProjectTaskList() {
    this.taskService.deleteProjectTasks(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getTaskForCurrentProject();
      this.selectedCheckboxData = []
      $('#closeModalDeleteProjectTask').click()
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.projectTaskGridForm.controls;
  }

  openProjectTaskKanban() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-task-kanban'], { queryParams: { projectID: this.currentProjectId } });
  }

  openProjectTaskGantt() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-task-gantt'], { queryParams: { projectID: this.currentProjectId } });
  }

  getprojectsList() {
    if (this.parentProjectId) {
      this.projectDropdownList = [];
      if (this.isAdministrator) {
        this.projectService.getSubProjects(this.parentProjectId).subscribe((response: any) => {
          for (let item of response) {
            this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
          }
        });
      } else {
        let ignoreArchived: boolean = true;
        this.projectService.getSubProjectActiveByUserId(this.userDetails.id, this.parentProjectId, ignoreArchived).subscribe((response: any) => {
          for (let item of response) {
            this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
          }
        });
      }

    } else {
      this.projectDropdownList = [];
      if (this.isAdministrator) {
        this.projectService.getProjects().subscribe((response: any) => {
          for (let item of response) {
            this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
          }
        });
      } else {
        let ignoreArchived: boolean = true;
        this.projectService.getProjectforActiveByUserId(this.userDetails.id, ignoreArchived).subscribe((response: any) => {
          for (let item of response) {
            this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
          }
        });
      }
    }
  }

  getAllTasksById() {
    this.taskDropdownList = []
    this.projecttaskService.getAllProjectTaskByProjectId(this.currentProjectId).subscribe((response: any) => {
      for (let item of response.result) {
        this.taskDropdownList.push(`${item.id} . ${item.name}`);
      }
    });
  }

  getProjectById(id) {
    this.projectService.getProjectForTask(id).subscribe((response: any) => {
      let lead = this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName;
      let creater = this.userDetails.firstName + " " + this.userDetails.lastName;
      let createrFullName = this.userDetails.firstName + " " + this.userDetails.middleName + " " + this.userDetails.lastName;
      if (response.projectManagerId === this.userDetails.id || response.projectController === lead || response.createdBy === creater || response.createdBy === createrFullName) {
        this.isPMOLeadORManager = true;
      }

      this.projectTaskGridForm.value.projectName = id + " . " + response.projectName;
      this.projectName = id + " . " + response.projectName
      let project = this.projectTaskGridForm.value.projectName;
      this.projectTaskGridForm.patchValue({ projectName: project.toString() });
    }, error => {
      this.openSnackBar(error);
    })
  }


  getSystemInformation() {
    if (!this.systemInformation) {
      this.taskService.getSystemInformation().subscribe((response: any) => {
        this.systemInformation = response;
        this.systemArray = Object.keys(response);
      });
    } else {
      this.systemArray = Object.keys(this.systemInformation);
    }
  }

  getSubSystemInformation(system) {
    if (this.modeAction === 2) {
      this.selectedSystem = system;
    }
    else {
      this.selectedSystem = system.target.value;
    }
    this.projectTaskGridForm.value.subSystem = '';
    this.projectTaskGridForm.value.subSubSystem = '';
    this.projectTaskGridForm.patchValue(this.projectTaskGridForm.value);
    if (this.systemArray) {
      this.subSystemArray = Object.keys(this.systemInformation[this.selectedSystem]);
    }
    else {
      alert("Please Select System Information First");
    }
  };

  getSubSubSystemInformation(subSystem) {
    if (this.modeAction === 2) {
      this.selectedSubSystem = subSystem;
    }
    else {
      this.selectedSubSystem = subSystem.target.value;
    }
    this.projectTaskGridForm.value.subSubSystem = '';
    this.projectTaskGridForm.patchValue(this.projectTaskGridForm.value);
    if (this.subSystemArray) {
      this.subSubSystemArray = this.systemInformation[this.selectedSystem][this.selectedSubSystem];
    }
    else {
      alert("Please Select System & Sub System Information First");
    }
  };

  getProjectResource() {
    this.taskOwnerDropdown = []
    this.projectResourcesService.getAllActiveProjectResourcesByProjectId(this.currentProjectId).subscribe((response: any) => {
      // this.projectResourcesService.getAllProjectResourcesByProjectId(this.currentProjectId).subscribe((response: any) => {
      // for (let item of response.result) {
      this.taskOwnerDropdown = response.result.map((item: any) => `${item.userId} . ${item.userName}`);
      // }
    });
  }

  createProjectTask() {
    let taskOwnersData: String;
    taskOwnersData = this.projectTaskGridForm.get('taskOwnerName').value.toString().replaceAll(",", " , ");
    let data = {
      name: this.projectTaskGridForm.get('name').value,
      projectId: parseInt((this.projectTaskGridForm.get('projectName').value).toString().substring(0, ((this.projectTaskGridForm.get('projectName').value).toString().indexOf('.')))),
      projectName: ((this.projectTaskGridForm.get('projectName').value).toString().substring(((this.projectTaskGridForm.get('projectName').value).toString().indexOf('.')) + 1)).trim(),
      system: this.projectTaskGridForm.get('system').value,
      subSystem: this.projectTaskGridForm.get('subSystem').value,
      subSubSystem: this.projectTaskGridForm.get('subSubSystem').value,
      description: this.projectTaskGridForm.get('description').value,
      startDate: this.projectTaskGridForm.get('startDate').value,
      endDate: this.projectTaskGridForm.get('endDate').value,
      taskOwners: taskOwnersData,
      //taskOwnerId: parseInt((this.projectTaskGridForm.get('taskOwnerName').value).toString().substring(0, ((this.projectTaskGridForm.get('taskOwnerName').value).toString().indexOf('.')))),
      //taskOwnerName: ((this.projectTaskGridForm.get('taskOwnerName').value).toString().substring(((this.projectTaskGridForm.get('taskOwnerName').value).toString().indexOf('.'))+1)).trim(),
      estimatedTimeInHours: this.projectTaskGridForm.get('estimatedTimeInHours').value,
      parentId: parseInt((this.projectTaskGridForm.get('parentName').value).toString().substring(0, ((this.projectTaskGridForm.get('parentName').value).toString().indexOf('.')))),
      parentName: ((this.projectTaskGridForm.get('parentName').value).toString().substring(((this.projectTaskGridForm.get('parentName').value).toString().indexOf('.')) + 1)).trim(),
      status: this.projectTaskGridForm.get('status').value,
      predecessorProjectTaskId: this.projectTaskGridForm.get('predecessorProjectTaskId').value.split(' . ')[0],
      successorProjectTaskId: this.projectTaskGridForm.get('successorProjectTaskId').value.split(' . ')[0],
      plannedStartDate: this.projectTaskGridForm.get('plannedStartDate').value,
      plannedEndDate: this.projectTaskGridForm.get('plannedEndDate').value,
      percentWorkCompleted: this.projectTaskGridForm.get('percentWorkCompleted').value,
      plannedStatus: this.projectTaskGridForm.get('plannedStatus').value
    }
    this.taskService.createBulkProjectTasks(data).subscribe(((response: any) => {
      if (this.orphanFiles && this.orphanFiles.length > 0) {
        this.projectTaskId = response.id;
        this.ignoreSnackbar = true;
        this.orphanFiles.forEach((file) => {
          this.selectedFile = file;
          this.onUploadAttachment();
        });
      }
      this.api.applyTransaction({ add: [response] });
      this.getTaskForCurrentProject();
      // this.backToMyProjectTask();
      $('#closeCreateModal').trigger("click");
    }));

    // this.taskService.createProjectTasks(data).subscribe((response: any) => {
    //   if(this.orphanFiles && this.orphanFiles.length > 0) {
    // this.projectTaskId = response.id;
    // this.ignoreSnackbar = true;
    // this.orphanFiles.forEach( (file) => {
    //   this.selectedFile = file;
    //   this.onUploadAttachment();
    // })
    //   }
    // this.api.applyTransaction({ add: [response] });
    // this.getTaskForCurrentProject();
    // // this.backToMyProjectTask();
    // $('#closeCreateModal').trigger("click");
    // });
  }


  updateProjectTask() {
    let data = {
      id: this.projectTaskGridForm.get('id').value,
      name: this.projectTaskGridForm.get('name').value,
      projectId: parseInt((this.projectTaskGridForm.get('projectName').value).toString().substring(0, ((this.projectTaskGridForm.get('projectName').value).toString().indexOf('.')))),
      projectName: ((this.projectTaskGridForm.get('projectName').value).toString().substring(((this.projectTaskGridForm.get('projectName').value).toString().indexOf('.')) + 1)).trim(),
      system: this.projectTaskGridForm.get('system').value,
      subSystem: this.projectTaskGridForm.get('subSystem').value,
      subSubSystem: this.projectTaskGridForm.get('subSubSystem').value,
      description: this.projectTaskGridForm.get('description').value,
      startDate: this.projectTaskGridForm.get('startDate').value,
      endDate: this.projectTaskGridForm.get('endDate').value,
      taskOwnerId: parseInt((this.projectTaskGridForm.get('taskOwnerName').value).toString().substring(0, ((this.projectTaskGridForm.get('taskOwnerName').value).toString().indexOf('.')))),
      taskOwnerName: ((this.projectTaskGridForm.get('taskOwnerName').value).toString().substring(((this.projectTaskGridForm.get('taskOwnerName').value).toString().indexOf('.')) + 1)).trim(),
      estimatedTimeInHours: this.projectTaskGridForm.get('estimatedTimeInHours').value,
      parentId: parseInt((this.projectTaskGridForm.get('parentName').value).toString().substring(0, ((this.projectTaskGridForm.get('parentName').value).toString().indexOf('.')))),
      parentName: ((this.projectTaskGridForm.get('parentName').value).toString().substring(((this.projectTaskGridForm.get('parentName').value).toString().indexOf('.')) + 1)).trim(),
      status: this.projectTaskGridForm.get('status').value,
      predecessorProjectTaskId: this.projectTaskGridForm.get('predecessorProjectTaskId').value.split(' . ')[0],
      successorProjectTaskId: this.projectTaskGridForm.get('successorProjectTaskId').value.split(' . ')[0],
      plannedStartDate: this.projectTaskGridForm.get('plannedStartDate').value,
      plannedEndDate: this.projectTaskGridForm.get('plannedEndDate').value,
      percentWorkCompleted: this.projectTaskGridForm.get('percentWorkCompleted').value,
      plannedStatus: this.projectTaskGridForm.get('plannedStatus').value,
    }
    this.taskService.updateProjectTasks(data, this.projectTaskId).subscribe(response => {
      this.api.applyTransaction({ add: [response] });
      this.getTaskForCurrentProject();
      this.onUploadAttachment();
      $('#closeCreateModal').trigger("click");
    });
  }

  public onFileChanged(event) {
    //Select File
    this.selectedFile = event.target.files[0];
  }

  onFileChangedBeforeTaskCreation(event) {
    if (event.target.files[0]) {
      this.orphanFiles.push(event.target.files[0] as never);
      this.projectTaskAttachments.push(event.target.files[0].name as never);
    }
  }

  onUploadAttachment() {
    if (!this.selectedFile) {
      return;
    }

    const fileData = new FormData();
    fileData.append('file', this.selectedFile, this.selectedFile.name);

    this.projecttaskService.uploadProjectTaskAttachments(
      Number(this.projectTaskId),
      fileData
    ).subscribe((response: any) => {
      if (response) {
        if (!this.ignoreSnackbar) {
          this.selectedFile = null;
          window.location.reload();
        }
      } else {
        this.selectedFile = null;
        window.location.reload();
      }
    });

    setTimeout(() => {
      this.getProjectTaskAttachments(this.projectTaskId);
    }, 400);
  }

  getProjectTaskAttachments(taskId) {
    this.projecttaskService.getProjectTaskAttachments(taskId).subscribe(
      (response) => {
        this.projectTaskAttachments = response;
      },
      (error) => {
      }
    );
  }

  deleteProjectTaskAttachments(value) {
    this.attachmentId = value.split(': ')[0];

    this.projecttaskService.deleteProjectTaskAttachments(
      this.projectTaskId,
      this.attachmentId
    ).subscribe(
      (response) => {
        window.alert('Delete Successful');
        this.getProjectTaskAttachments(this.projectTaskId)
      },
      (error) => {
      }
    );
  }

  deleteProjectTaskAttachmentsBeforeTaskCreation(value) {
    this.projectTaskAttachments = this.projectTaskAttachments.filter((attachment) => {
      return attachment != value;
    });

    this.orphanFiles = this.orphanFiles.filter((file) => {
      return file.name != value;
    })
  }

  downloadProjectTaskAttachments(value) {
    this.attachmentId = value.split(': ')[0];
    this.attachemntName = value.split(': ')[1];

    this.projecttaskService.downloadProjectTaskAttachments(
      this.projectTaskId,
      this.attachmentId
    ).subscribe(
      (response: HttpResponse<Blob>) => {
        let filename: string = this.attachemntName;
        let binaryData = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      (error) => {
      }
    );
  }

  openProjectGantt() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-task-gantt'], { queryParams: { projectID: this.currentProjectId } });
  }

  openProjectKanban() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-task-kanban'], { queryParams: { projectID: this.currentProjectId } });
  }

}
